import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-216">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-gradient-to-br from-[#1A1A1A] to-[#0A0A0A] border border-[#25F4EE]/20 rounded-3xl p-8 md:p-10 shadow-[0_0_50px_rgba(37,244,238,0.1)]" data-id="element-217">
        <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-218">
          Presento:{' '}
          <span className="text-[#25F4EE]" data-id="element-219">
            TikTok Shop Afiliados en 14 Días (US)
          </span>
          <span className="block text-xl md:text-2xl font-bold text-gray-400 mt-2" data-id="element-220">
            — Starter Sprint en Español
          </span>
        </h2>

        <p className="text-lg text-gray-300 mb-8" data-id="element-221">
          Un sprint diseñado para el perfil impulsivo + aspiracional. No para
          hacerte "influencer". Sino para que salgas con:
        </p>

        <ul className="space-y-4" data-id="element-222">
          {['una selección simple de producto (por señal, no por emoción)', 'guiones listos para grabar', 'un calendario diario de 14 días', 'un tablero anti-abandono para el momento exacto en que siempre te vas'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-223">
              <div className="mt-1 min-w-[24px] h-6 flex items-center justify-center rounded-full bg-[#25F4EE]/20" data-id="element-224">
                <Check className="w-4 h-4 text-[#25F4EE]" data-id="element-225" />
              </div>
              <span className="text-lg text-white font-medium" data-id="element-226">{item}</span>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}